import React, { useState, useEffect } from "react";
import { getTriviaFileName, isLibraryImageItem } from "../data";
import { Button, Col, Popover, Row, PopoverBody } from "reactstrap";
import { BsDownload, BsThreeDots } from "react-icons/bs";
import LibraryQuestionGenerateModal from "./Components/LibraryQuestionGenerateModal";
import { contvertHTMLToPlain } from "../../../utils/constants";
import { isMobile } from "../../../utils/deviceInfo";
import ReactTooltip from "react-tooltip";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions";
import { connect } from "react-redux";
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutDataLines,
  LayoutRowLines,
} from "../../../components/TableComponents/RowCardShadow/RowCardShadow";
import moment from "moment";
import { BiEditAlt, BiTrashAlt } from "react-icons/bi";
import LibraryQuestionEditModal from "./Components/LibraryQuestionEditModal";
import DeleteQuestionModal from "./Components/DeleteQuestionModal";
import { toastContainer } from "../../../utils/toast";
import TriviaList from "../TriviaList";
import { withRouter } from "react-router";
import ScheduleQuestionsModal from "./Components/ScheduleQuestionsModal";
import { MdSchedule, MdOutlineAutoAwesome } from "react-icons/md";

import SidebarComponent from "./Components/SidebarComponent";

function LibraryTrivvys({ library,libQuestions,user,updateLibraryTrivvyCount,updateLibraryDoc, ...props }) {
  const [triviaList, setTriviaList] = useState([]);
  const [scheduleQuestionsModal, setScheduleQuestionsModal] = useState(false);

  const onScheduleSuccess = (newTrivvys) => {
    updateLibraryTrivvyCount({
      typeTrivvy: "INC",
      valueTrivvy: newTrivvys.length,
    });
    setTriviaList([...newTrivvys,...triviaList])
    setScheduleQuestionsModal(false);
  };

  useEffect(() => {
    axios
      .post(url.getTrivvysLinkedToLibrary, {
        libraryId: library._id,
        sourceLink: library.s3Url,
      })
      .then(({ data }) => {
        setTriviaList(data.data);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    axios
      .post(url.getTrivvysLinkedToLibrary, {
        libraryId: library._id,
        sourceLink: library.s3Url,
      })
      .then(({ data }) => {
        setTriviaList(data.data);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  const onDeleteFromLibList=()=>{
    updateLibraryTrivvyCount({
      typeTrivvy: "DEC",
      valueTrivvy:1,
    });
  }

  return (
    <div>
      <Row className={!isMobile ? "trivia_edit_ui_height_wrapper mx-0 px-0":""}>
        <SidebarComponent updateLibraryDoc={updateLibraryDoc} libraryQuestions={libQuestions} library={library} />

        {scheduleQuestionsModal && (
        <ScheduleQuestionsModal
          onClose={() => {
            setScheduleQuestionsModal(false);
          }}
          open={scheduleQuestionsModal}
          onScheduleSuccess={onScheduleSuccess}
          
          library={library}
          embeddedInTrivvyCreateModal={false}
       
          
          goToTrivvyTab={() =>
            props.history.push(
              `/home/trivia/${user.profile.organizationId._id}/library-item/${library._id}/view/trivvys`
            )
          }
        />
      )}

        <Col sm={10} className={isMobile ? "p-2" :"px-5  center-main-trivia-ui"}>
        <div className={isMobile ?"d-flex":""}>
              {/* <Button
                style={{ height: !isMobile? "35px":"30px",whiteSpace:"pre",padding:isMobile?"3px 5px":"5px 8px" }}
                className="trivia-action-button-main"
                onClick={() => setQuestionGenerateModal(true)}
              >
                <MdOutlineAutoAwesome /> Generate Questions
              </Button> */}
              {/* An image has no text to generate Trivvys from. */}
              {!isLibraryImageItem(library) && (
              <Button
                onClick={() => {
                  setScheduleQuestionsModal(true);
                }}
                // className="ml-3 trivia-schedule-btn"
                className="trivia-action-button-main mt-4 libScheduleTrivvyBtn"
                // color="primary"
                style={{ height: !isMobile? "35px":"30px",whiteSpace:"pre",padding:isMobile?"3px 5px":"5px 8px",fontSize:"14px" }}
              >
                <MdSchedule size={"17px"}/>
                Schedule Trivvys
              </Button>
              )}
            </div>
          
          <TriviaList
          className="trivvy-list-library-container"
            showTrivvyListOnly
            trivvyListPrefetchedArray={triviaList}
            onDeleteFromLibList={onDeleteFromLibList}

            {...props}
          />
        </Col>
      </Row>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.triviaList
        ? state.sortFilterParams.triviaList.sort &&
          state.sortFilterParams.triviaList.sort.hasOwnProperty("sortBy")
          ? state.sortFilterParams.triviaList.sort
          : { sortBy: "", sortOrder: "" }
        : { sortBy: "", sortOrder: "" },
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateSortParams: data => dispatch(actionCreators.updateTriviaSort(data)),
    updateLibraryTrivvyCount: (data) =>
    dispatch(actionCreators.updateSingleLibrarayStatsForTrivvyCount(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LibraryTrivvys));
